export default {
  state: {
    desadvs: [],
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'edi_desadvs.id',
      order: 'descending',
    },
  },
  getters: {
    desadvs: state => state.desadvs,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setDesadvs(state, desadvs) {
      state.desadvs = desadvs;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchAll({ commit, state }, queryString) {
      commit('setLoading', true);
      try {
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const desadvs = await axios.get('api/desadvs' + query);
        commit('setDesadvs', desadvs);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/desadvs/${id}`);
    },
    async fetchSource({ commit }, orderId) {
      return await axios.get(`api/customer-orders/${orderId}/desadv-source`);
    },
    async fetchSelectableOrders({ commit }) {
      return await axios.get('api/desadvs/selectable-orders');
    },
    async createFromOrder({ commit }, payLoad) {
      return await axios.post('api/desadvs', payLoad);
    },
    async delete({ commit }, id) {
      return await axios.delete(`api/desadvs/${id}`);
    },
    async finalize({ commit }, id) {
      return await axios.post(`api/desadvs/${id}/finalize`);
    },
    async fetchPallet({ commit }, id) {
      return await axios.get(`api/desadv-pallets/${id}`);
    },
    async createPallet({ commit }, desadvId) {
      return await axios.post(`api/desadvs/${desadvId}/pallets`);
    },
    async updatePallet({ commit }, { id, payLoad }) {
      return await axios.put(`api/desadv-pallets/${id}`, payLoad);
    },
    async finalizePallet({ commit }, id) {
      return await axios.post(`api/desadv-pallets/${id}/finalize`);
    },
    async deletePallet({ commit }, id) {
      return await axios.delete(`api/desadv-pallets/${id}`);
    },
    async createShipment({ commit }, desadvId) {
      return await axios.post('api/desadv-shipments', { edi_desadv_id: desadvId });
    },
    // payLoad: { position?, delivery_date? } - keys are sent verbatim,
    // so delivery_date must be present with null to clear the date.
    async updateShipment({ commit }, { id, payLoad }) {
      return await axios.put(`api/desadv-shipments/${id}`, payLoad);
    },
    async assignShipmentPallets({ commit }, { id, palletIds }) {
      return await axios.post(`api/desadv-shipments/${id}/assign-pallets`, { pallet_ids: palletIds });
    },
    async closeShipment({ commit }, id) {
      return await axios.post(`api/desadv-shipments/${id}/close`);
    },
    // Only for a closed shipment whose earlier send failed. The shipment goes to
    // 'queued' here; the outcome lands on it once the background job is done.
    async sendShipment({ commit }, id) {
      return await axios.post(`api/desadv-shipments/${id}/send`);
    },
    async deleteShipment({ commit }, id) {
      return await axios.delete(`api/desadv-shipments/${id}`);
    },
  },
};
